import { IonAccordion } from '@ionic/react';
import { IonicButton } from 'ionic-ui';
import React, { ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { NewStoreSchema } from '../../../../../../schemas/storeGetStartedSchema';
import z from 'zod';
import FileDropBox from '../../../../../../components/ui/FileDropBox/FileDropBox';
import AccordionHeader from '../../../../../../components/Dashboard/getting-started/accordion/AccordionHeader';
import { cropperAspectRatios } from '../../../../../../Constants/imageAspectRatios';
import { RootState } from '../../../../../../store/store';
type Props = {
  onSave: () => Promise<void> | void;
} & ComponentProps<typeof IonAccordion>;
export default function StoreBrandAccordion({
  onSave,
  value = 'Store-brand',
  ...res
}: Props) {
  const {
    control,
    formState: { isDirty },
  } = useFormContext<z.infer<typeof NewStoreSchema>>();

  const activeStore = useSelector(
    (state: RootState) => state.userStores.activeStore
  );
  const existingLogoUrl = activeStore?.media?.logo?.file_url;
  const existingBannerUrl = activeStore?.media?.banner?.file_url;

  return (
    <IonAccordion value={value} {...res}>
      <AccordionHeader>Store Brand</AccordionHeader>
      <div
        slot="content"
        className="flex flex-col p-4 gap-4 bg-background dark:bg-background-accent"
      >
        <Controller
          control={control}
          name="store_logo"
          render={({ field, fieldState }) => (
            <div>
              <label className="medium-emphasis-text mb-1 block text-sm">
                Upload store logo*
              </label>
              <FileDropBox
                {...field}
                value={field.value}
                onChange={field.onChange}
                allowCropping={true}
                allowPreview
                existingPreviewUrl={existingLogoUrl}
                acceptedTypes={{ 'image/jpeg': ['.jpeg', '.png'] }}
                maxFiles={1}
                cropperAspectRatio={cropperAspectRatios.profile_image}
                errorMessage={fieldState.error?.message}
              />
            </div>
          )}
        />
        <Controller
          control={control}
          name="store_banner"
          render={({ field, fieldState }) => (
            <div>
              <label className="medium-emphasis-text mb-1 block text-sm">
                Upload store banner
              </label>
              <FileDropBox
                {...field}
                value={field.value}
                onChange={field.onChange}
                maxFiles={1}
                allowCropping={true}
                allowPreview
                existingPreviewUrl={existingBannerUrl}
                cropperAspectRatio={cropperAspectRatios.banner}
                acceptedTypes={{ 'image/jpeg': ['.jpeg', '.png'] }}
                errorMessage={fieldState.error?.message}
              />
            </div>
          )}
        />
        <div className="py-4">
          <IonicButton
            type="button"
            onClick={onSave}
            disabled={!isDirty}
            className="w-full rounded-sm"
          >
            Save
          </IonicButton>
        </div>
      </div>
    </IonAccordion>
  );
}
